import React, { useState, useEffect } from "react";
import Logo from "../../../assets/boj-images/dark_boj.png";
import backgroundImage from "../../../assets/boj-images/login_banner.jpeg";
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";
import { message } from "antd";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { Spinner } from "react-bootstrap";
import Footer from "../../superAdmin/footer/Footer";
import useBranding from "../../../hooks/useBranding";
import { portalAuth } from "../../../utils/portalAuth";
const capitalizeFirstLetter = (string) => {
  if (!string) return "";
  return string.charAt(0).toUpperCase() + string.slice(1);
};

function SuperAdminAreaLogin() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const { logoUrl, backgroundUrl } = useBranding();
  const navigate = useNavigate();
  const pathname = window.location.pathname;
  const userType = pathname.split("/")[1];
  console.log("helllo i am here ", capitalizeFirstLetter(userType));
  localStorage.setItem("exhibitor_agent_type", capitalizeFirstLetter(userType));

  const exhibitorAgentType = localStorage.getItem("exhibitor_agent_type");

  const handleKeyDown = (event) => {
    if (event.key === "Enter") {
      handleChange();
    }
  };

  useEffect(() => {
    if (portalAuth.getActiveToken()) {
      navigate(`/${exhibitorAgentType.toLowerCase()}/dashboard`);
    }
  }, []);

  const handleChange = () => {
    setIsLoading(true);
    if (!email) {
      message.error("Enter username or email");
      setIsLoading(false);
      return;
    }
    if (!password) {
      message.error("Enter password");
      setIsLoading(false);

      return;
    } else {
      // Exhibitor portal access enabled
      /*
      if (exhibitorAgentType === "Exhibitor") {
        message.info("This portal has been closed.");
        setIsLoading(false);
        return;
      }
      */
      axios
        .post(`${process.env.REACT_APP_API_END_POINT}/login`, {
          email,
          password,
        })
        .then((response) => {
          // insert token in localstorage — portal-scoped
          const portal = portalAuth.getActivePortal();
          portalAuth.setAuth(
            portal,
            response.data.token,
            response.data.category.permissions,
            response.data.category._id,
            `/${exhibitorAgentType.toLowerCase()}/login`
          );
          localStorage.setItem("user_id", response.data.category._id);
          localStorage.setItem("jff_token", response.data.token);
          setIsLoading(false);
        })
        .catch((error) => {
          setIsLoading(false);
          console.log(error);
        })
        .finally(() => {
          let data = portalAuth.getActivePermission();
          data = JSON.parse(data);

          console.log("data", data);

          let nameArray = [];

          // console.log("ssdsssasdasa",data[i])
          axios
            .post(
              `${process.env.REACT_APP_API_END_POINT}/get-permission-name`,
              {
                permission: data,
              }
            )
            .then((res) => {
              console.log(".data.data", res.data.data);
              nameArray = res.data.data;

              if (nameArray.includes("exhibitor")) {
                console.log("running inside if");
                navigate(`/${exhibitorAgentType.toLowerCase()}/dashboard`);
              } else {
                message.error("Access Denied");
              }
            });
        });
    }
  };

  return (
    <>
      <div>
        <div className="container-fluid">
          <div className="row vh-100">
            <div
              className="col-lg-12 col-md-12  d-lg-block p-0 img-col"
              style={{ position: "fixed" }}
            >
              <img
                src={backgroundUrl || backgroundImage}
                alt="Placeholder"
                className="img-fluid vh-100 w-60 top-img"
              />
            </div>
            <div className="col-lg-7 col-md-7 d-flex flex-column align-items-center justify-content-center ms-auto p-4">
              {/* Logo */}
              <img
                src={logoUrl || Logo}
                alt="logo-img"
                style={{ width: "250px" }}
              />

              {/* Login Card */}
              <div
                className="exhibitorlogin w-[250 px]"
              >
                <div className="exhibitorloginbody">
                  <div className="fw-semi-bold fs-3 text-center mb-3">
                    {localStorage.getItem("exhibitor_agent_type")} Login
                  </div>

                  <Form>
                    <Form.Control
                      type="username"
                      placeholder="Username"
                      className="my-3"
                      onChange={(e) => setEmail(e.target.value)}
                      required
                      onKeyDown={handleKeyDown}
                    />

                    <Form.Control
                      type="password"
                      placeholder="Password"
                      className="my-3"
                      onChange={(e) => setPassword(e.target.value)}
                      required
                      onKeyDown={handleKeyDown}
                    />

                    <Button
                      className="my-3 btn-block w-100"
                      onClick={handleChange}
                      disabled={isLoading}
                    >
                      {isLoading ? (
                        <Spinner animation="border" size="sm" />
                      ) : (
                        "Login"
                      )}
                    </Button>
                  </Form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default SuperAdminAreaLogin;
